import { render, staticRenderFns } from "./BaseSaleItemDoorphoneModal.vue?vue&type=template&id=d36efb40&scoped=true"
import script from "./BaseSaleItemDoorphoneModal.vue?vue&type=script&lang=js"
export * from "./BaseSaleItemDoorphoneModal.vue?vue&type=script&lang=js"
import style0 from "./BaseSaleItemDoorphoneModal.vue?vue&type=style&index=0&id=d36efb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36efb40",
  null
  
)

export default component.exports